module.exports = __webpack_public_path__ + "img/Triceratops Esport Logo.jpg";